import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const top = ref("0");
const observer = new ResizeObserver(updateTop);
const element = ref<HTMLElement | null>(null);

function updateTop() {
    let el = element.value;
    if (el == undefined) {
        return;
    }

    let newTop = 0;
    while (el.previousSibling) {
        const sibling = el.previousSibling as HTMLElement;
        if (sibling.dataset && "vSticky" in sibling.dataset) {
            newTop += sibling.offsetHeight;
        }
        el = sibling;
    }
    top.value = newTop + "px";
}

nextTick(updateTop);
document.fonts.ready.then(updateTop);

onMounted(() => {
    const el = element.value?.parentElement;
    if (el) {
        observer.observe(el);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sticky",
    style: _normalizeStyle({ top: top.value }),
    ref_key: "element",
    ref: element,
    "data-v-sticky": ""
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})